import { css } from '@emotion/react'
import { Cell } from 'bold-ui'
import { TextAreaField } from 'components/form'
import { Fragment } from 'react'
import { MetaPath } from 'util/metaPath'

import { AntropometriaAccordionModel } from './AntropometriaAccordion'

interface PacMembroInferiorFieldProps {
  name: MetaPath<AntropometriaAccordionModel>
}

export function PacMembroInferiorField(props: Readonly<PacMembroInferiorFieldProps>) {
  const { name } = props

  return (
    <Fragment>
      <Cell size={6}>
        <TextAreaField
          name={name.membroInferiorDireito}
          label='Membro inferior direito'
          placeholder='Insira informações sobre o membro inferior direito, como exames realizados'
          maxLength={250}
          resize='vertical'
          style={styles.textArea}
        />
      </Cell>
      <Cell size={6}>
        <TextAreaField
          name={name.membroInferiorEsquerdo}
          label='Membro inferior esquerdo'
          placeholder='Insira informações sobre o membro inferior esquerdo, como exames realizados'
          maxLength={250}
          resize='vertical'
          style={styles.textArea}
        />
      </Cell>
    </Fragment>
  )
}
const styles = {
  textArea: css`
    height: 136px;
  `,
}
